import React from "react";
import {Warehouse} from "mdi-material-ui";

export default function Depo(props) {
    return (
        <Warehouse className={props.className} />
    );
};